const lowerBound = -143;

export const rssisToRgb = (rssiPerGateway: Record<string, number>): string => {
  const rssi = Math.max(...Object.values(rssiPerGateway));

  if (rssi >= 0) return '#00FF00';
  if (rssi <= lowerBound) return '#FF0000';

  const red = Math.floor(Math.pow(rssi / lowerBound, 3) * 255);
  const green = 255 - red;
  return `rgb(${red},${green},0)`;
};

export const rssisToColorClass = (rssiPerGateway?: Record<string, number>): string | undefined => {
  if (!rssiPerGateway) return undefined;

  const rssi = Math.max(...Object.values(rssiPerGateway));

  if (rssi >= 0) return 'color-nominal';
  if (rssi <= lowerBound) return 'color-danger';

  const scaled = Math.pow(rssi / lowerBound, 3);
  if (scaled < 0.333) {
    return 'color-nominal';
  } else if (scaled > 0.666) {
    return 'color-danger';
  }

  return 'color-warning';
};
